import { useQuery } from "urql";
import { PAIR_QUERY } from "../graphql/queries";
import { useState } from "react";
import { useEffect } from "react";

export const usePair = (networkId, pairAddress) => {
  const [pair, setPair] = useState(null);

  const [result] = useQuery({
    query: PAIR_QUERY,
    variables: {
      input: {
        networkId,
        pair: pairAddress,
      },
    },
    pause: !networkId || !pairAddress,
  });

  const { data, fetching, error } = result;

  useEffect(() => {
    if (data?.pair) {
      setPair(data.pair);
    }
  }, [data]);

  useEffect(() => {
    setPair(null);
  }, [pairAddress]);

  return {
    pair,
    loading: fetching,
    error,
  };
};
